import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import SendCandidats from '../SendCandidats/SendCandidats';
import LoadingPopup from '../../commun/LoadingPopup';
import './TravailMission.css';

const TravailMission = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mission, setMission] = useState(null);
  const [entreprise, setEntreprise] = useState(null);
  const [activeTab, setActiveTab] = useState('mission');

  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");

 
  const params = new URLSearchParams(location.search);
  const preselectedTalentId = params.get('t');

  useEffect(() => {
    const fetchMission = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/missions/${id}`);
        const data = await res.json();
        setMission(data);
        fetchEntreprise(data.createdBy);
      } catch (err) {
        console.error('Erreur chargement mission:', err);
      }
    };

    const fetchEntreprise = async (userId) => {
      try {
        const res = await fetch(`${API_BASE}/api/entreprise/profil/${userId}`);
        const data = await res.json();
        setEntreprise(data);
      } catch (err) {
        console.error('Erreur chargement entreprise:', err);
      }
    };

    fetchMission();
  }, [id, API_BASE]);

  if (!mission || !entreprise) {
    return <LoadingPopup open message="Chargement..." />;
  }

  return (
    <div className="travail-mission-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />

      <main className="travail-mission-container">
        {/* Partie gauche avec onglets */}
        <section className="mission-info-section">
          <div className="tab-navigation">
            <button
              className={activeTab === 'mission' ? 'active' : ''}
              onClick={() => setActiveTab('mission')}
            >
              MISSION
            </button>
            <button
              className={activeTab === 'profil' ? 'active' : ''}
              onClick={() => setActiveTab('profil')}
            >
              PROFIL RECHERCHÉ
            </button>
          </div>

          <div className="tab-content-travaill">
            {activeTab === 'mission' && (
              <MissionInfo
                mission={mission}
                editable={false}
                isRecruteurView={true}
                entrepriseLogo={entreprise.logo}
              />
            )}
            {activeTab === 'profil' && (
              <ProfilRecherche
                editedMission={mission}
                editable={false}
                entrepriseLogo={entreprise.logo}
              />
            )}
          </div>
        </section>

        {/* Partie droite avec formulaire de candidats */}
        <section className="send-candidats-section">
          <SendCandidats preselectedTalentId={preselectedTalentId} />
        </section>
      </main>
    </div>
  );
};

export default TravailMission;
